var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('el-button',{staticClass:"ButtonSend",attrs:{"type":"success","disabled":_vm.isDisabled},on:{"click":_vm.check}},[_vm._v("Revisar")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }